var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('manage-collective-gateways', 'ipg-gateway'))?_c('main-content',[_c('gateway-form',{attrs:{"submit":_vm.createGateway,"form_data":_vm.collective}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }